(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_slide"] && !Shopify.designMode) return;
  try {
    /*
   * Touch swipe: pause autoplay while a finger is on the slideshow, so the automatic
   * slide change cannot fight the swipe. Autoplay resumes shortly after the touch ends.
   */
  (() => {
    if (window.__slideshowTouchPause) return;
    window.__slideshowTouchPause = true;

    let resumeTimer;

    const findSlideshow = (event) =>
      event.target instanceof Element ? event.target.closest('slideshow-component') : null;

    document.addEventListener(
      'touchstart',
      (event) => {
        const slideshow = findSlideshow(event);
        if (!slideshow || typeof slideshow.suspend !== 'function') return;
        clearTimeout(resumeTimer);
        slideshow.suspend();
      },
      { passive: true }
    );

    const onTouchEnd = (event) => {
      const slideshow = findSlideshow(event);
      if (!slideshow || typeof slideshow.resume !== 'function') return;
      clearTimeout(resumeTimer);
      resumeTimer = setTimeout(() => slideshow.resume(), 4000);
    };

    document.addEventListener('touchend', onTouchEnd, { passive: true });
    document.addEventListener('touchcancel', onTouchEnd, { passive: true });
  })();
  } catch(e) { console.error(e); }
})();

})();
